package org.example.project.service

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.serialization.json.put
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import org.w3c.files.File

object ProfilDocumentApi {
    internal val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun uploadDocument(userId: String, file: File, fileName: String = file.name): Boolean {
        if (userId.isBlank()) return false
        val headers = LumaticaApiManager.auditHeaders(file.type.ifBlank { "application/octet-stream" }).apply {
            append("x-file-name", fileName)
        }
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/profil/upload-document/${apiPart(userId)}",
            RequestInit(
                method = "POST",
                headers = headers,
                body = file
            )
        ).await()
        if (!response.ok) return false
        val raw = response.text().await()
        return runCatching {
            json.parseToJsonElement(raw).jsonObject["ok"]?.jsonPrimitive?.content == "true"
        }.getOrDefault(false)
    }

    suspend fun uploadCompanyDocument(firmenId: String, userId: String, file: File, fileName: String = file.name): Boolean {
        if (firmenId.isBlank() || userId.isBlank()) return false
        val headers = LumaticaApiManager.auditHeaders(file.type.ifBlank { "application/octet-stream" }).apply {
            append("x-file-name", fileName)
        }
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/profilverwaltung/upload-document/${apiPart(firmenId)}/${apiPart(userId)}",
            RequestInit(
                method = "POST",
                headers = headers,
                body = file
            )
        ).await()
        if (!response.ok) return false
        val raw = response.text().await()
        return runCatching {
            json.parseToJsonElement(raw).jsonObject["ok"]?.jsonPrimitive?.content == "true"
        }.getOrDefault(false)
    }

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
